import React from 'react'
import { Box, Container, Typography } from '@mui/material'
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined'
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined'
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined'
import type { FeatureListItemType } from '../../../../../types/ui'
import FeatureListItem from '@zuto/atoms/src/Mui/Card/FeatureListItem'
import { formlessColors } from '@zuto/theme/src/mui/Colors'

const featureItems: FeatureListItemType[] = [
  {
    icon: {
      component: TimelineOutlinedIcon,
      bg: formlessColors.surfaceIndigoSoft,
      color: formlessColors.iconIndigo
    },
    title: 'Track your progress',
    description: 'See live updates on your application and what to expect next.'
  },
  {
    icon: {
      component: DirectionsCarOutlinedIcon,
      bg: formlessColors.surfaceGreenSoft,
      color: formlessColors.iconGreen
    },
    title: 'Find a car you love',
    description: "Browse 40,000+ cars if you don't already have one in mind."
  },
  {
    icon: {
      component: CloudUploadOutlinedIcon,
      bg: formlessColors.surfaceSkySoftAlt,
      color: formlessColors.iconSkyAlt
    },
    title: 'Upload the things we need',
    description: 'Upload documents and complete ID checks safely and securely.'
  }
]

const MyZutoAccountSection: React.FC = () => {
  return (
    <Container
      sx={{
        width: '100%',
        backgroundColor: 'background.paper',
        boxSizing: 'border-box',
        paddingLeft: 5,
        paddingRight: 5,
        marginTop: 9
      }}
      maxWidth="md"
      component="section"
      id="my-zuto-account-section"
    >
      <Box>
        <Typography component="h2" variant="headlineMedium">
          Your My Zuto Account
        </Typography>

        <Typography variant="bodyLarge" sx={{ marginBottom: 8 }} component="p">
          Head to your My Zuto account now to track your application and complete steps online,
          helping everything move quickly.
        </Typography>

        <Box sx={{ marginTop: '8px' }}>
          {featureItems.map((item, index) => (
            <FeatureListItem
              key={item.title}
              {...item}
              sx={{
                marginBottom: index === featureItems.length - 1 ? 0 : '12px'
              }}
            />
          ))}
        </Box>
      </Box>
    </Container>
  )
}

export default MyZutoAccountSection
